export const standardFieldLabelSx = {
  mb: 0.4,
  fontWeight: 600,
  lineHeight: 1.2,
  color: '#475569',
};
